


































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IBulkAction } from "@/models/bulkactions";
import { DataModules } from "@/store/modules/data";
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import { BACKEND_DATETIME_FORMAT } from "@/data/date";

@Component
export default class BulkActionScheduleModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  @Prop({ required: true })
  public bulkAction!: IBulkAction;

  public form = {
    started_at: new Date(),
    name: ""
  };

  public processing = false;

  public created() {
    this.form.name = this.bulkAction.name;
    this.form.started_at = new Date();
  }

  public get formIsDisabled() {
    if (this.$_.isEmpty(this.form.name)) {
      return true;
    }
    if (!this.$_.isDate(this.form.started_at)) {
      return true;
    }
    return false;
  }

  public validateBeforeSubmit() {
    this.processing = true;
    this.validate()
      .then(result => {
        if (result) {
          return this.rescheduleBulkAction();
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.$store.dispatch("toast/show", {
          message: this.$t("_sentence.successfully_saved")
        });
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => (this.processing = false));
  }

  public rescheduleBulkAction() {
    return this.$store
      .dispatch(`data/${DataModules.BULK_ACTIONS}/reschedule`, {
        vm: this,
        id: this.bulkAction.id,
        data: {
          refresh_segment: 1,
          draft: true,
          name: this.form.name,
          started_at: this.$moment(this.form.started_at)
            .utc()
            .format(BACKEND_DATETIME_FORMAT)
        }
      })
      .then(() => {
        this.$emit("success");
      })
      .catch(error => {
        this.$store.dispatch("toast/error", { message: error.message });
      });
  }
}
